import {CssBaseline, StyledEngineProvider, ThemeProvider} from '@mui/material';
import {BrowserRouter} from 'react-router';
import {AuthProvider} from 'src/auth/AuthProvider';
// import {CompatRouter} from 'react-router';
import {RoutesManager} from 'src/RoutesManager';
// import {createStore, StoreContext} from './stores';
import {theme} from './theme';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {isLocalhost} from 'src/utils/other';

// import {persistQueryClient} from 'react-query/persistQueryClient-experimental'
// import {createWebStoragePersistor} from 'react-query/createWebStoragePersistor-experimental'

// React Query
const oneMinute = 60 * 1000;
// const oneHour = 60 * oneMinute;

export const queryOptions = {
  staleTime: 10 * oneMinute, // stale after 10 minutes
  cacheTime: 30 * oneMinute, // cache GC'd after 30 minutes

  // 4 retries unless local dev
  retry: isLocalhost() ? false : 4, // was false during June 2023
  // other retry examples
  // retry: 6 - retries 6 times before showing the final error
  //   thrown by the function.
  // retry: true - infinitely retries failing requests.
  // retry: (failureCount, error) => ...
  //   allows custom logic based on the error. See AzurePage.tsx.

  // Retry Schedule
  // Start at 5sec, double each attempt, don't exceed 30sec.
  // Mainly meant to deal with timeouts while indexing etc.
  // According to Christian:
  // "The load balancer will probably throw a 503 after 30 seconds."
  retryDelay: (attemptIndex: number) =>
    Math.min(5000 * 2 ** attemptIndex, 30000),

  //
  // values for cache persistence
  // staleTime: 2 * oneHour, // stale after 2 hours
  // cacheTime: 4 * oneHour, // cache GC'd after 4 hours

};
const queryClient = new QueryClient({
  defaultOptions: {
    queries: queryOptions,
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <AuthProvider>
              <RoutesManager />
            </AuthProvider>
            <CssBaseline />
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
};
